import { Injectable } from '@angular/core';
import { AccountManagerActivityDrawerWrapperComponent } from '@sbd-doug-frontend/app/modules/accounts/accounts-manager/account-list/account-manager-vtabs/account-manager-activity/account-manager-activity-drawer-wrapper.component';
import type { ActivityCallFormDraft } from '@sbd-doug-frontend/shared/lib/types/activity-viewer/activity-event-log.types';
import { CIPXDrawerContentInterface } from '@sbd-doug-frontend/shared/lib/ui/drawer/drawer-content.interface';
import { CIPXDrawerManagerService, DrawerRef } from '@sbd-doug-frontend/shared/lib/ui/drawer/drawer-manager.service';
import { PersistentDrawerTab } from './persistent-drawer-tabs.service';
import { PersistentDrawerOpener } from './persistent-drawer-registry.service';

@Injectable()
export class ActivityPersistentDrawerOpener implements PersistentDrawerOpener {
  readonly type = 'activity';

  constructor(private _drawerManagerService: CIPXDrawerManagerService) {}

  open(tab: PersistentDrawerTab): DrawerRef<CIPXDrawerContentInterface<any>> {
    const accountId = Number(tab.context['accountId']);
    const instanceId = String(tab.context['instanceId'] || `activity-drawer-${tab.id}`);
    const scopeKey = String(tab.context['scopeKey'] || `activity:${accountId || 'global'}:drawer`);
    const activityId = tab.context['activityId'] as string | number | null | undefined;
    const quoteRequestId = tab.context['quoteRequestId'] as number | null | undefined;
    const accountUserId = tab.context['accountUserId'] as number | null | undefined;
    const accountLabel = tab.context['accountLabel'] as string | null | undefined;
    const callDraft = (tab.context['callDraft'] as ActivityCallFormDraft | null | undefined) ?? null;

    return this._drawerManagerService.openDrawer(AccountManagerActivityDrawerWrapperComponent, {
      keepOnNavigation: true,
      showCollapseButton: true,
      title: tab.title,
      data: {
        tabId: tab.id,
        accountId: Number.isFinite(accountId) ? accountId : null,
        accountLabel: accountLabel ?? null,
        instanceId,
        scopeKey,
        quoteRequestId: quoteRequestId ?? null,
        accountUserId: accountUserId ?? null,
        activityId: activityId ?? null,
        callDraft,
        title: tab.title,
      },
    });
  }
}
